export default "__VITE_ASSET__DtMjBPcp__"